<div [class]="asRow ? 'flex flex-row justify-between items-start gap-x-2' : ''" [class.w-full]="fullWidth" [class.w-fit]="!fullWidth">
  @if (truncateTitleText) {
    <p mxTruncate [mxTruncateMaxLines]="truncateTitleTextMaxLines" class="{{titleCSSClasses}}">{{ titleText }}</p>
  } @else {
    <p class="{{titleCSSClasses}}">{{ titleText }}</p>
  }

  @if (truncateValue) {
    <p mxTruncate [mxTruncateMaxLines]="truncateValueMaxLines" class="{{valueCSSClasses}}">
      <ng-container *ngTemplateOutlet="valueContents"/>
    </p>
  } @else {
    <p class="{{valueCSSClasses}}">
      <ng-container *ngTemplateOutlet="valueContents"/>
    </p>
  }
</div>

<ng-template #valueContents>
  @if (valueRouterLink) {
    <a [mxNamedRouterLink]="valueRouterLink" [mxNamedRouterLinkParams]="valueRouterLinkParams" [mxQueryParams]="valueRouterLinkQueryParams">
      <ng-container *ngTemplateOutlet="simpleValue"/>
    </a>
  } @else {
    <ng-container *ngTemplateOutlet="simpleValue"/>
  }
</ng-template>

<ng-template #simpleValue>
  {{ value | format:'REPLACE_EMPTY' }}
</ng-template>
